<div class="{{listIcons ? 'col-10' : 'col-12'}}">
  <h1 class="page-title line-height-auto">
    {{title | translate}}
    <span *ngIf="ownership && ownership.permission && ownership.permission.toString() == 'Owner'" class="d-flex ownership-icons">
      <ownership-select [type]="'visibility'" [value]="ownership.visibleTo" (onSave)="saveVisibleTo($event)"><i class="fa fa-eye"></i></ownership-select>
      <ownership-select [type]="'editable'" [value]="ownership.editableFor" (onSave)="saveEditableFor($event)"><i class="fa fa-pencil"></i></ownership-select>
      <span badge badge-info *ngIf="ownership && ownership.ownerName">
         {{'Owned by' | translate}} <strong>{{ ownership.ownerName }}</strong>
      </span>
    </span>
  </h1>
</div>
